// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link, NavLink } from 'react-router-dom'
import { DateTime } from 'luxon'

// Internal Dependencies:
import VerseList from 'components/Verses/VerseList'
import AudioRecorder from 'utilities/AudioRecorder'
import Text from 'components/Form/Text'
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'

// Redux:
import { getVersesData, sendVersesRecording } from 'actions/votd'

class VersePage extends React.Component {
	constructor( props ) {
		super( props )

		let sumbitter_name = props.userName || ''
		let email = props.userEmail || ''

		if ( props.accountData ) {
			sumbitter_name = props.accountData.name
			email = props.accountData.email
		}

		this.state = {
			verseData: false,
			sumbitter_name: sumbitter_name,
			email: email,
			isRecording: false,
			finishedRecording: false,
			recordingPreview: false,
			acceptedRecording: false,
			sent: false,
			duration: '0',
			audioBlob: false
		}
		this.thisYear =  DateTime.local().toFormat( 'y' )
	}

	componentDidMount() {
		const { verses, match } = this.props
		let verseDate = match.params.verse ? match.params.verse : false

		window.scrollTo( 0, siteData.page_top_pos )
		document.querySelector( '.main' ).scrollTop = 0

		if ( verseDate ) {
			this.props.getVersesData( `${this.thisYear}-${verseDate}`, true )
		}

		this.getData()
		this.setup()
	}

	componentDidUpdate() {
		this.getData()
	}

	getData = () => {
		if ( this.state.verseData ) {
			return
		}

		const { verses, match } = this.props
		let verseDate = match.params.verse ? match.params.verse : false

		if ( ! verseDate ) {
			return
		}

		let verseData = verses.all[ `${this.thisYear}-${verseDate}` ] ? verses.all[ `${this.thisYear}-${verseDate}` ] : false

		if ( ! verseData ) {
			return
		}

		this.setState({
			verseData: verseData
		})
	}

	setup = () => {
		this.recorder = new AudioRecorder()
		this.recorder.em.addEventListener( 'recording', ( e ) => this.onNewRecording( e ) )
	}

	startRecording = () => {
		this.recorder.startRecording()
			.then(() => {
				this.setState({
					isRecording: true
				})
			})
			.catch( ( error ) => {
				console.error( 'Exception while start recording: ' + error )
				alert( 'Unable to record.' )
				// alert( 'Exception while start recording: ' + error.message ) // Debug.
			})
	}

	stopRecording = () => {
		this.recorder.stopRecording()

		this.setState({
			isRecording: false
		})
	}

	onNewRecording = ( e ) => {
		window.scrollTo( 0, siteData.page_top_pos )
		document.querySelector( '.main' ).scrollTop = 0

		let extension = 'wav'

		if ( e.detail.recording.mimeType.indexOf( 'webm' ) > -1 ) {
			extension = 'webm'
		} else if ( e.detail.recording.mimeType.indexOf( 'wav' ) > -1 ) {
			extension = 'wav'
		}

		this.setState({
			isRecording: false,
			finishedRecording: true,
			audioBlob: e.detail.blob,
			extension: extension,
			recordingPreview: e.detail.recording
		})
	}

	sendRecording = () => {
		const { audioBlob, extension, sumbitter_name, email, verseData } = this.state

		this.props.sendVersesRecording( audioBlob, extension, sumbitter_name, email, verseData.date )
	}

	handleRecordClick = () => {
		const { isRecording } = this.state

		if ( ! isRecording ) {
			this.startRecording()
		} else {
			this.stopRecording()
		}
	}

	handleRedoClick = () => {
		this.setState({
			finishedRecording: false,
			audioBlob: false,
			recordingPreview: false
		})
	}

	handleAcceptClick = () => {
		this.setState({
			acceptedRecording: true
		})
	}

	handleSubmitterDeatilsChange = ( id, value ) => {
		this.setState({
			[ id ]: value
		})
	}

	handleSendClick = () => {
		const { history } = this.props

		this.sendRecording()

		this.setState({
			isRecording: false,
			finishedRecording: false,
			sent: true
		})

		setTimeout( () => {
			this.setState({
				sent: false
			})

			// Redirect back:
			history.push( '/votd' )
		}, 2000 )
	}

	render() {
		const { isMobile } = this.props
		const { verseData, isRecording, finishedRecording, recordingPreview, acceptedRecording, sent, duration, sumbitter_name, email } = this.state
		const className = isRecording ? 'is-recording votd-verse-page-content mobile-app-top-page' : 'votd-verse-page-content mobile-app-top-page'

		if ( ! verseData ) {
			return <LoadingSpinner />
		}

		return (
			<div className={ className }>
				<div className="-bg"></div>

				{ finishedRecording && recordingPreview && ! acceptedRecording && ! sent &&
					<div className="-preview -form">
						<h3>Verse recorded!</h3>

						<audio src={ recordingPreview.blobUrl } controls="true" />

						<div className="button" onClick={ this.handleRedoClick }>Record again</div>
						<div className="button" onClick={ this.handleAcceptClick }>Accept</div>
					</div>
				}

				{ finishedRecording && acceptedRecording && ! sent &&
					<div className="-form">
						<h3>Verse recorded!</h3>

						<p className="-sub-heading">Enter your details:</p>

						<Text
							id="sumbitter_name"
							label="Name"
							value={ sumbitter_name }
							onChange={ this.handleSubmitterDeatilsChange }
						/>

						<Text
							id="email"
							type="email"
							label="Email"
							value={ email }
							onChange={ this.handleSubmitterDeatilsChange }
						/>

						<div className="button" onClick={ this.handleSendClick }>Send to Faith FM</div>

						<p className="-note">
							By sending you give Faith FM the right to edit and broadcast your recording on public radio.
						</p>
					</div>
				}

				{ ! finishedRecording && ! sent &&
					<div className="-text">
						<div className="-intro">
							{ ! isMobile &&
								<p className="-intro-note">
									Note: Try recording on your mobile phone - you might get better results.<br />
									If you do make a recording on your desktop, make sure you come close to your microphone and check the audio quality of your recording before submitting it.
								</p>
							}

							<p>
								Hi, I’m ______ from ______ , and I’m here to share our verse of the day from<br />
								<span className="-ref">{ verseData.reference }</span>.
							</p>
						</div>

						<div className="-verse-text">
							<p  dangerouslySetInnerHTML={ { __html: verseData.verse } } />
						</div>

						<div className="-outro">
							<p>
								You’re listening to Faith FM.
							</p>
						</div>
					</div>
				}

				{ ! finishedRecording && ! sent &&
					<div className="-record">
						<div className="-button" onClick={ this.handleRecordClick }>
							{ isRecording &&
								<i className="icon-playback-pause" aria-hidden="true"></i>
							||
								<svg viewBox="0 0 16 16">
									<path className="-mic-base" d="M9,12.86 L9,14 L9.5,14 C10.15,14 10.69,14.42 10.9,15 L5.1,15 C5.31,14.42 5.85,14 6.5,14 L7,14 L7,12.86 C5.28,12.41 4,10.86 4,9 L4,7 L5,7 L5,9 C5,10.66 6.34,12 8,12 C9.66,12 11,10.66 11,9 L11,7 L12,7 L12,9 C12,10.86 10.72,12.41 9,12.86 L9,12.86 L9,12.86 Z"/>
									<path className="-mic-top" d="M8,11 C6.9,11 6,10.1 6,9 L6,3 C6,1.9 6.9,1 8,1 C9.1,1 10,1.9 10,3 L10,9 C10,10.1 9.1,11 8,11 L8,11 L8,11 Z"/>
								</svg>
							}
						</div>
					</div>
				}

				{ sent &&
					<div className="-sent">
						<h3>Sent!</h3>
					</div>
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		accountData: state.site.accountData,
		verses: state.votd.verses,
		userName: state.schedule.userName,
		userEmail: state.schedule.userEmail,
		isMobile: state.site.isMobile
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getVersesData( verseDate, single = false ) {
			dispatch( getVersesData( verseDate, single ) )
		},

		sendVersesRecording( blob, extension, name, email, date ) {
			dispatch( sendVersesRecording( blob, extension, name, email, date ) )
		}
	}
}

export default withRouter(
	connect( mapStateToProps, mapDispatchToProps )( VersePage )
)
